import { Switch, SwitchProps } from '@nextui-org/react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface SwitchControlProps<T extends FieldValues>
    extends Omit<SwitchProps, 'onChange'> {
    name: Path<T>
    control: Control<T>
    label: string
    onChangeCustom?: (checked: boolean) => void
}

export function SwitchControl<T extends FieldValues>({
    name,
    control,
    label,
    onChangeCustom,
    ...props
}: SwitchControlProps<T>): React.ReactElement {
    const { t } = useTranslation()

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <div className="flex items-center justify-between w-full gap-4">
                    <label
                        htmlFor={name}
                        className="text-sm flex-1 truncate"
                    >
                        {t(label)}
                    </label>
                    <Switch
                        {...field}
                        {...props}
                        id={name}
                        isSelected={field.value === true}
                        onValueChange={(checked) => {
                            field.onChange(checked)
                            if (onChangeCustom) {
                                onChangeCustom(checked)
                            }
                        }}
                    />
                </div>
            )}
        />
    )
}
